/** @jsx jsx */
import { jsx } from 'theme-ui'
import { Link } from 'gatsby'
import BTPGraphic3 from '../images/BTP-graphic3.png'
import Layout from '../components/layout'
import SEO from '../components/seo'

const ContactPage = () => (
  <Layout activeMenu="contact">
    <SEO title="Contact" />

    <div className="banner_w3lspvt-2">
      <ol className="breadcrumb">
        <li className="breadcrumb-item">
          <Link to="/" className="font-weight-bold">
            Home
          </Link>
        </li>
        <li className="breadcrumb-item" aria-current="page">
          Contact Us
        </li>
      </ol>
    </div>

    <div className="contact py-5" id="contact">
      <div className="container pb-xl-5 pb-lg-3">
        <div sx={{ justifyContent: 'center' }} className="row">
          <div className="col-lg-6">
            <img
              src={BTPGraphic3}
              alt="Developer at a computer"
              className="img-fluid"
              style={{ marginTop: `52px` }}
            />
          </div>
          <div className="col-lg-6 mt-lg-0 mt-5 text-center">
            <div className="contact-top1">
              <form
                name="contact"
                action="/thank-you"
                method="post"
                className="contact-wthree-do"
                data-netlify="true"
                data-netlify-honeypot="bot-field"
              >
                <input type="hidden" name="form-name" value="contact" />
                <div className="form-group">
                  <div className="row">
                    <div className="col-md-6">
                      <label for="name">Full name</label>
                      <input
                        className="form-control"
                        type="text"
                        name="name"
                        required=""
                      />
                    </div>
                  </div>
                </div>
                <div className="form-group">
                  <div className="row">
                    <div className="col-md-6 mt-md-0 mt-4">
                      <label for="email">Email</label>
                      <input
                        className="form-control"
                        type="email"
                        name="email"
                        required=""
                      />
                    </div>
                  </div>
                </div>
                <div className="form-group">
                  <div className="row">
                    <div className="col-md-12">
                      <label for="message">Message</label>
                      <textarea
                        name="message"
                        className="form-control"
                      ></textarea>
                    </div>
                  </div>
                </div>
                <div className="row mt-3">
                  <div className="col-md-12">
                    <button
                      type="submit"
                      className="btn btn-cont-w3 btn-block mt-4"
                    >
                      Send
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
)

export default ContactPage
